import { captureException } from '@sentry/vue';

const DEVICE_ID_TIMEOUT_MS = 1500;

let deviceId: Promise<string | undefined> | undefined;

const computeDeviceId = async (): Promise<string | undefined> => {
  try {
    const { default: FingerprintJS } = await import('@fingerprintjs/fingerprintjs');
    const agent = await FingerprintJS.load({ monitoring: false });
    return (await agent.get()).visitorId;
  } catch (error) {
    captureException(error, { tags: { action: 'getDeviceId' } });
    return undefined;
  }
};

export const getDeviceId = (): Promise<string | undefined> => {
  deviceId ??= computeDeviceId();
  const timeout = new Promise<undefined>((resolve) => setTimeout(resolve, DEVICE_ID_TIMEOUT_MS));

  return Promise.race([deviceId, timeout]);
};
